import validate from "/Users/james/www/ecomm/apps/front2/node_modules/.pnpm/nuxt@3.15.4_@types+node@22.14.0_eslint@9.23.0_less@4.2.2_sass@1.86.2_typescript@5.8.2_vite@6.2.5/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Users/james/www/ecomm/apps/front2/node_modules/.pnpm/nuxt@3.15.4_@types+node@22.14.0_eslint@9.23.0_less@4.2.2_sass@1.86.2_typescript@5.8.2_vite@6.2.5/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  client: () => import("/Users/james/www/ecomm/apps/front2/middleware/client.ts")
}